// Module
var code = `<ul class="countdown list-inline" ng-if="\$ctrl.targetDatetimes">
  <li>
    <span class="days">{{\$ctrl.clock.days}}</span>
    <div class="cd-label">Days</div>
  </li>
  <li>
    <span class="hours">{{\$ctrl.clock.hours}}</span>
    <div class="cd-label">Hours</div>
  </li>
  <li>
    <span class="minutes">{{\$ctrl.clock.minutes}}</span>
    <div class="cd-label">Minutes</div>
  </li>
  <li>
    <span class="seconds">{{\$ctrl.clock.seconds}}</span>
    <div class="cd-label">Seconds</div>
  </li>
</ul>
`;
// Exports
export default code;